/**
 * The reading in progress, which no event has recorded yet: time only
 * reaches the log when the reader leaves an article or a page. Without it,
 * a stats view opened while reading would show the time of earlier visits
 * only. The reader registers how to ask for it; nothing here is stored or
 * sent.
 */
export interface LiveReading {
	/** The article being read, when the layout reads by article. */
	articleId?: number;
	elapsedMs: number;
	/** 0 to 1, when the layout knows it. */
	depth?: number;
}

let live: (() => LiveReading | undefined) | null = null;

export function setLiveReading(read: (() => LiveReading | undefined) | null): void {
	live = read;
}

export function getLiveReading(): LiveReading | undefined {
	try {
		return live?.();
	} catch {
		return undefined;
	}
}
